export const columns = [
  {
    field: "id",
    headerName: "ID",
    width: 40,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>ID</strong>,
  },
  {
    field: "name_complete",
    headerName: "NOMBRE",
    minWidth: 240,
    flex: 1,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>NOMBRE</strong>,
  },
  {
    field: "pending_guides",
    headerName: "GUÍAS PENDIENTES",
    width: 240,
    resizable: false,
    sortable: false,
    align: "right",
    renderHeader: (params) => <strong>PENDIENTES DE DEVOLUCIÓN</strong>,
  },
  {
    field: "delivered_guides",
    headerName: "GUÍAS ENTREGADAS",
    type: "string",
    width: 110,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "right",
    renderHeader: (params) => <strong>ENTREGADAS</strong>,
  },
  {
    field: "failed_delivered_guides",
    headerName: "GUÍAS PENDIENTES DEVOLUCIÓN",
    type: "string",
    width: 100,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "right",
    renderHeader: (params) => <strong>FALLIDAS</strong>,
  },
  {
    field: "region",
    headerName: "REGIÓN",
    type: "string",
    width: 100,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "left",
    renderHeader: (params) => <strong>REGIÓN</strong>,
  },
  {
    field: "balance",
    headerName: "SALDO",
    type: "string",
    width: 80,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "left",
    renderHeader: (params) => <strong>SALDO</strong>,
  },
];
